import React from 'react';
import { Gradient } from '../Gradient';

const Ticket = ({ type, className = '', color = '#737373' }) => {
  return (

<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M5.2123 3.18483V4.85167M5.2123 6.51851V8.18535M5.2123 9.85219V10.6856M5.2123 1.51799V0.684571M7.71256 8.18535H13.1298M7.71256 5.68509H10.6295M3.12875 0.68457H14.7966C15.7172 0.68457 16.4635 1.43084 16.4635 2.35141V3.18483C16.4635 3.64511 16.068 4.00098 15.6642 4.222C15.1472 4.50502 14.7966 5.05411 14.7966 5.68509C14.7966 6.31607 15.1472 6.86516 15.6642 7.14818C16.068 7.3692 16.4635 7.72506 16.4635 8.18535V9.01877C16.4635 9.93934 15.7172 10.6856 14.7966 10.6856L3.12875 10.6856C2.20818 10.6856 1.46191 9.93934 1.46191 9.01877V8.18535C1.46191 7.72506 1.85739 7.3692 2.26114 7.14818C2.77816 6.86516 3.12875 6.31607 3.12875 5.68509C3.12875 5.05411 2.77816 4.50502 2.26114 4.222C1.85739 4.00098 1.46191 3.64512 1.46191 3.18483V2.35141C1.46191 1.43084 2.20818 0.68457 3.12875 0.68457Z" 
stroke={type === 'plain' ? color : 'url(#globalGradient)'} 
      strokeWidth="1" 
      strokeLinecap="round"/>
      <Gradient className={className} />
</svg>


  );
};

export default Ticket;